var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"提示","visible":_vm.acceptInfo.boolean},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('p',[_vm._v(_vm._s(_vm.acceptInfo.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }